import {BaseGlobalErrorHandler} from "@kta20-core/interfaces/base-global-error-handler";
import {SINGLETON_CLASS} from "@kta20-core/constants";
import {Translation} from "@kta20-core/resources/lang/en";
import {IUiServices} from "@kta20-core/interfaces/i-ui-services";
import {ErrorPresentModes, ErrorSeverities} from "@kta20-core/errors/custom-error";


/**
 * Logs error remotely when remote logging
 * is enabled (method injected from kta20-error-reporting
 * module). Otherwise logs locally.
 * @param err
 */
const logError=(err)=>{
    if(console['logRemote'])
        (<any>console).logRemote(err);
    else {
        const severity = err['getSeverity'] ? err['getSeverity']() : ErrorSeverities.UNRECOVERABLE;
        (severity===ErrorSeverities.UNRECOVERABLE) ? console.error(err) : console.warn(err);
    }
};


//Expects to work with a globally available "console" object.
export class GlobalErrorHandler extends BaseGlobalErrorHandler{

    private static inst:GlobalErrorHandler;
    private tr:Translation;


    static get(owner:any, onError:string, onUnhandledRejection:string, iUiService:IUiServices, T:Translation): BaseGlobalErrorHandler {
        if (!this.inst){
            this.inst = new GlobalErrorHandler();
            this.inst.uiService = iUiService;
            this.inst.tr = T;
            // Commented because i can not see the erorrs in console

            /**/
            owner[onError] = this.inst.onError.bind(this.inst);
            //onUnhandledRejection;
            owner[onUnhandledRejection] = this.inst.onUnhandledRejection.bind(this.inst);
        }

        return this.inst;
    }

    constructor() {
        super();
        if (GlobalErrorHandler.inst)
            throw new Error(SINGLETON_CLASS);
    }

    onError(err:Error) {
        try{
            this.configureToastAndDisplay(err);
        }
        catch (err) {
            logError(err);
        }
    }

    onUnhandledRejection(event:PromiseRejectionEvent|any) {
            try{
                //NOTE: This is only meaningful in Chrome that supports this event.
                event.preventDefault();

                // The native event-handler in Chrome puts the Reason and Promise in the
                // root event, but Bluebird attaches them to the event detail.
                const reason = ( event.reason || event.detail.reason );

                console.group( "UNHANDLED PROMISE REJECTION" );
                logError( reason );
                console.groupEnd();

                this.configureToastAndDisplay(reason);
            }
            catch (e) {
                logError(e);
                console.log(event);
            }
    }

    private configureToastAndDisplay(err:Error|any){
        if(!err['getPresentMode'] || err.getPresentMode()===ErrorPresentModes.GENERIC_TO_USER)
            err.message = this.tr.generic_error;

        const severity = (err['getSeverity'] ? (<any>err).getSeverity() : ErrorSeverities.UNRECOVERABLE);
        const duration = severity === ErrorSeverities.UNRECOVERABLE ? 0 : 3000;
        this.uiService.displayToastError(err.message, duration, severity);
    }

}
